import React, { Component } from 'react'

export default class Footer extends Component {
    render() {
        return (
            <>
                <footer className="ftco-footer ftco-section " style={{ marginTop: "30px" }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <p>
                                    Copyright &copy;
						<script>document.write(new Date().getFullYear());</script> All rights reserved by <a href="#"
                                        target="_blank">Tongil Kim</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </footer>

            </>
        )
    }
}
